import { defineComponent as _defineComponent } from 'vue'
import domService from '@/core/dom.service';
    import QuoteLineViewObject = Vertica.LouisPoulsen.Application.SalesDocuments.ViewModels.QuoteLineViewObject;
    import InvoiceLineViewObject = Vertica.LouisPoulsen.Application.SalesDocuments.ViewModels.InvoiceLineViewObject;
    import OrderLineViewObject = Vertica.LouisPoulsen.Application.SalesDocuments.ViewModels.OrderLineViewObject;
import { Key } from '@/core/keycodes';
import _ from 'lodash';
import {
    SalesDocumentMobileOverlayType
} from '@/ui/views/salesdocumenttable/salesdocument.types';
import { useTranslations } from '@/core/translate.mixin';
import { computed, onMounted, onUnmounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesDocumentTableMobileOverlay',
  props: {
    parentData: null,
    data: null,
    viewType: null
  },
  emits: ["close", "onListImageZoom"],
  setup(__props: any, { emit }: { emit: ({(e: 'close'): void, (e:'onListImageZoom', images: CarouselImageViewObject[]): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    parentData: OrderHeaderViewObject | InvoiceHeaderViewObject | QuoteHeaderViewObject | any,
    data: Array<OrderLineViewObject | InvoiceLineViewObject | QuoteLineViewObject>,
    viewType: SalesDocumentMobileOverlayType
}




const initialized = ref<boolean>(false);
const expandedIndexes = ref<number[]>([]);

onMounted(() => {
    domService.addElementClass('html', 'mobile-detail-overlay-open');
    document.addEventListener('keydown', closeOverlayOnEsc);
    window.setTimeout(() => {
        initialized.value = true;
    }, 350);
});

onUnmounted(() => {
    domService.removeElementClass('html', 'mobile-detail-overlay-open');
    document.removeEventListener('keydown', closeOverlayOnEsc);
});

function isExpanded(index):boolean {
    return _.includes(expandedIndexes.value, index);
}

function expand(index):void {
    const isExpandedValue = isExpanded(index);
    if (isExpandedValue) {
        expandedIndexes.value = _.without(expandedIndexes.value, index);
    } else {
        expandedIndexes.value.push(index);
    }
}

function close():void {
    emit('close');
}

function onListImageZoom(images: CarouselImageViewObject[]):void {
    emit('onListImageZoom', images);
}

function closeOverlayOnEsc(event: KeyboardEvent) {
    if (event.keyCode === Key.ESC && close) {
        close();
    }
}

const { t } = useTranslations();

// animation
function beforeEnter(el) { el.style.height = '0'; }
function enter(el) { el.style.height = el.scrollHeight + 'px'; }
function beforeLeave(el) { el.style.height = el.scrollHeight + 'px'; }
function leave(el) { el.style.height = '0'; }

const titleLabel = computed<string>(() => {
    return isQuoteView.value
        ? t('Pages.PartnerPortal.Quotes.QuotePage.QuoteMobileOverlayTitle', [props.parentData.quoteNo])
        : isOrderView.value ? t('Pages.PartnerPortal.Orders.OrderPage.OrderMobileOverlayTitle', [props.parentData.orderNo]) : t('Pages.PartnerPortal.Invoices.InvoicePage.InvoiceMobileOverlayTitle', [props.parentData.invoiceNo]);
});

const creationDateLabel = computed<string>(() => {
    return isQuoteView.value
        ? 'Pages.PartnerPortal.Quotes.QuotePage.QuoteTableCreationDate'
        : isOrderView.value ? 'Pages.PartnerPortal.Orders.OrderPage.OrderTableCreationDate' : 'Pages.PartnerPortal.Invoices.InvoicePage.InvoiceTableCreationDate';
});

const netValueLabel = computed<string>(() => {
    return isQuoteView.value
        ? 'Pages.PartnerPortal.Quotes.QuotePage.QuoteTableNetValue'
        : isOrderView.value ? 'Pages.PartnerPortal.Orders.OrderPage.OrderTableNetValue' : 'Pages.PartnerPortal.Invoices.InvoicePage.InvoiceTableNetValue';
});

const referenceLabel = computed<string>(() => {
    return isQuoteView.value
        ? 'Pages.PartnerPortal.Quotes.QuotePage.QuoteTableReference'
        : isOrderView.value ? 'Pages.PartnerPortal.Orders.OrderPage.OrderTableReference' : 'Pages.PartnerPortal.Invoices.InvoicePage.InvoiceTableReference';
});

const pdfLinkLabel = computed<string>(() => {
    return isQuoteView.value
        ? 'Pages.PartnerPortal.Quotes.QuotePage.QuoteTablePdfLink'
        : isOrderView.value ? 'Pages.PartnerPortal.Orders.OrderPage.OrderTablePdfLink' : 'Pages.PartnerPortal.Invoices.InvoicePage.InvoiceTablePdfLink';
});

const pdfLinkUrl = computed<string>(() => {
    return isQuoteView.value
        ? props.parentData.quotePdfLink
        : isOrderView.value ? props.parentData.orderPdfLink : props.parentData.invoicePdfLink;
});

const materialLabel = computed<string>(() => {
    return isQuoteView.value
        ? 'Pages.PartnerPortal.Quotes.QuotePage.QuoteTableLineMaterial'
        : isOrderView.value ? 'Pages.PartnerPortal.Orders.OrderPage.OrderTableLineMaterial' : 'Pages.PartnerPortal.Invoices.InvoicePage.InvoiceTableLineMaterial';
});

const mainQuoteOrInvoiceLabel = computed<string>(() => {
    return isQuoteView.value ? 'Pages.PartnerPortal.Quotes.QuotePage.QuoteTableSalesOrderNo' : 'Pages.PartnerPortal.Invoices.InvoicePage.InvoiceTableOrder';
});

function orderOrInvoiceNumber(invoiceOrOrderOrQuoteLine):string {
    return isQuoteView.value
        ? invoiceOrOrderOrQuoteLine.orderNumber
        : isOrderView.value ? invoiceOrOrderOrQuoteLine.invoiceNumber : invoiceOrOrderOrQuoteLine.orderNumber;
}

function orderOrInvoiceLink(invoiceOrOrderOrQuoteLine):string {
    return isQuoteView.value
        ? invoiceOrOrderOrQuoteLine.orderUrl
        : isOrderView.value ? invoiceOrOrderOrQuoteLine.invoiceUrl : invoiceOrOrderOrQuoteLine.orderUrl;
}

const orderOrInvoiceLinkLabel = computed<string>(() => {
    return isQuoteView.value
        ? 'Pages.PartnerPortal.Quotes.QuotePage.QuoteTableLineSalesOrderNo'
        : isOrderView.value ? 'Pages.PartnerPortal.Orders.OrderPage.OrderTableLineInvoiceNo' : 'Pages.PartnerPortal.Invoices.InvoicePage.InvoiceTableLineOrder';
});

const isQuoteView = computed<boolean>(() => {
    return props.viewType === SalesDocumentMobileOverlayType.quote;
});

const isOrderView = computed<boolean>(() => { return props.viewType === SalesDocumentMobileOverlayType.order; });

return { __sfc: true,props, emit, initialized, expandedIndexes, isExpanded, expand, close, onListImageZoom, closeOverlayOnEsc, t, beforeEnter, enter, beforeLeave, leave, titleLabel, creationDateLabel, netValueLabel, referenceLabel, pdfLinkLabel, pdfLinkUrl, materialLabel, mainQuoteOrInvoiceLabel, orderOrInvoiceNumber, orderOrInvoiceLink, orderOrInvoiceLinkLabel, isQuoteView, isOrderView }
}

})